import { Tween } from "@westpierstudio/luma/createjs";
import { Signal } from "type-signals";

export type MessageCycleSettings = {
    idleCycleTime: number,
    interruptionCycleTime: number,
    cycleLength: number
}

export class MessageCycleController {

    protected settings: MessageCycleSettings;
    protected interruptionTimeTarget = {progress: 0};
    protected idleTimeTarget = {progress: 0};
    protected shouldCycleWhenInterruptionComplete = false;
    protected interruptionTimerInProgress = false;


    protected currentCycleIndex = 0;

    signals = {
        cycle: new Signal<(cycleIndex: number)=>void>()
    };

    constructor(settings: MessageCycleSettings) {
        this.settings = settings;
    }

    getAndIncrementCycleIndex() {
        return (++this.currentCycleIndex) % this.settings.cycleLength;
    }

    interrupt() {
        this.clearIdleTimer();
        if (!this.isInterruptionTimerInProgress()) {
            this.startInterruptionTimer();
        }
    }

    interruptionComplete() {
        if (this.shouldCycleWhenInterruptionComplete) {
            this.shouldCycleWhenInterruptionComplete = false;
            this.signals.cycle.dispatch(this.getAndIncrementCycleIndex());
        }
        this.idle();
    }

    idle() {
        this.clearIdleTimer();
        this.startIdleTimer();
    }

    clearAndStopCycling() {
        this.shouldCycleWhenInterruptionComplete = false;
        this.currentCycleIndex = 0;
        this.clearIdleTimer();
        this.clearInterruptionTimer();
    }

    reset() {
        this.clearAndStopCycling();
    }

    protected startInterruptionTimer() {
        this.interruptionTimerInProgress = true;
        Tween.get(this.interruptionTimeTarget)
            .wait(this.settings.interruptionCycleTime)
            .call(() => this.onInterruptionTimerComplete());

    }

    protected isInterruptionTimerInProgress() {
        return this.interruptionTimerInProgress;
    }

    protected onInterruptionTimerComplete() {
        this.interruptionTimerInProgress = false;
        this.startInterruptionTimer();
        this.shouldCycleWhenInterruptionComplete = true;
    }

    protected startIdleTimer() {
        this.idleTimeTarget.progress = 0;
        Tween.get(this.idleTimeTarget)
            .wait(this.settings.idleCycleTime)
            .call(() => this.onIdleTimerComplete());
    }

    protected onIdleTimerComplete() {
        this.shouldCycleWhenInterruptionComplete = false;
        this.clearInterruptionTimer();
        this.startIdleTimer();
        this.signals.cycle.dispatch(this.getAndIncrementCycleIndex());
    }


    protected clearIdleTimer() {
        Tween.removeTweens(this.idleTimeTarget);
        this.idleTimeTarget.progress = 0;
    }

    protected clearInterruptionTimer() {
        Tween.removeTweens(this.interruptionTimeTarget);
        this.interruptionTimeTarget.progress = 0;
        this.interruptionTimerInProgress = false;
    }
}